// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { themr } from "react-css-themr";
import { Page, Link, H } from "@lifepay/rc-ui-toolkit";
import { withRouter } from "react-router";

// ABSOLUTE PATH IMPORTS

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Page.m.scss";

@withRouter
@themr("PageLayout", styles)
export default class PageLayout extends Component {
  static propTypes = {
    theme: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
    pageHeader: PropTypes.string,
    children: PropTypes.node,
  };

  render() {
    const { theme, basePath, match, pageHeader, children } = this.props;
    return (
      <Page
        header={pageHeader}
        showHeader={false}
        breadcrumb={() => (
          <React.Fragment>
            <Link type="alt" to={`/`}>
              {"главная"}
            </Link>
            <div>{"->"}</div>
            <Link type="alt" to={`${basePath}/search`}>
              {"поиск клиента"}
            </Link>
            <div>{"->"}</div>
            <Link type="alt" to={`${basePath}/${match.params.clientId}/menu`}>
              {"выбор действия"}
            </Link>
            <div>{"->"}</div>
            <H t={"h4"}>{pageHeader}</H>
          </React.Fragment>
        )}
      >
        <div className={classnames(theme.wrapper)}>
          <div className={classnames(theme.content)}>{children}</div>
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/pages/Page/Page.js